import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {CommentsFetchModel} from "./comments.fetch-model";
import {COMMENTS_URL} from "../../../core/consts";

export class CommentsRequestParams extends BaseApiRequestParams {
  url: String;
  fetchModel: CommentsFetchModel;

  constructor(fetchModel: CommentsFetchModel) {
    super(null, fetchModel);

    this.url = COMMENTS_URL;
    this.usePrefix = false;
  }

  toString(): string {
    return this.url;
  }

  equals(model: BaseApiRequestParams): Boolean {
    return this.fetchModel.equals(model);
  }
}
